import PcseoDoctorSearch from "@jdh-cargo/block-pcseo-doctor-search";
import ArticleCard from "@jdh-cargo/block-content-article-card";
import InquiryCard from "@jdh-cargo/block-content-inquiry-card";
import { homeNav } from "./homeNav";
import { Template } from "./template";
import { setHospitalTDK } from "utils/hospital";
import { useEffect, useMemo, useRef, useState } from "react";
import evaluate5 from "../../asset/img/login/evaluate5.png";
import { useParams } from "react-router-dom";
import { emptyObjValueOfAll2 } from "../../utils/emptyObjValueOfAll";
import {
  excuteFassScript,
  getHospitalDetailByHospitalId,
} from "../../api/disease";
import queryString from "query-string";

// import PcseoDoctorSearch from "./dist";

import styles from "./index.less";

export function useGetAllParams(ParamsHasBottomLineMapKeyList: string[] = []) {
  const localParams = useParams<Record<any, any>>();

  const paramsInfo = useMemo(() => {
    const _localParams = localParams;
    // ParamsHasBottomLine 是特殊的参数，用来支持下划线的方式传递参数
    const ParamsHasBottomLine = _localParams?.ParamsHasBottomLine;
    if (
      ParamsHasBottomLine &&
      ParamsHasBottomLine.length &&
      ParamsHasBottomLineMapKeyList.length
    ) {
      delete _localParams.ParamsHasBottomLine;

      const arr = ParamsHasBottomLine.split("_");
      const obj = {};
      ParamsHasBottomLineMapKeyList.forEach((k, index) => {
        if (k) {
          const val = arr?.[index];
          if (val !== undefined) {
            // @ts-ignore
            obj[k] = val;
          }
        }
      });

      if (Object.keys(obj).length === 1) {
        // @ts-ignore
        const val1 = obj[ParamsHasBottomLineMapKeyList[0]];
        const arr = val1.split("-");
        ParamsHasBottomLineMapKeyList.forEach((k, index) => {
          if (k) {
            const val = arr?.[index];
            // @ts-ignore
            obj[k] = val;
          }
        });
      }

      Object.assign(_localParams, obj);
    }
    return emptyObjValueOfAll2(
      _localParams,
      queryString.parse(window.location.search)
    );
  }, [localParams]);
  return paramsInfo;
}

export function PageContent(props: any) {
  const { paramsInfo = {} } = props;
  console.log(111, "PageContent paramsInfo", paramsInfo);

  const {
    selectedProvince,
    cityId,
    diseaseId,
    provinceId,
    hospitalId,
    secondDepartId,
    departmentId,
    secondDepartName,
  } = paramsInfo;

  setHospitalTDK(
    "京东健康 - 互联网医院",
    "京东健康互联网医院,网上预约挂号,网上问诊",
    "京东健康互联网医院提供在线问诊、慢病管理、加号等服务的互联网医疗平台，患者在家看专家，线上处方，线上药房，药品配送到家。私人医生长期照护，体检报告专家解读，给你专业的分析和建议。大三甲医院的专家号，一号难求，挂号难，京东健康互联网医院免费加号，让患者轻松看上大专家，找对医生挂对号！"
  );

  const [articleLimit, setArticleLimit] = useState<any>(3);

  const [hospital, setHospital] = useState("");
  const [depart, setDepart] = useState("");
  const [areaName, setAreaName] = useState("");

  const [des, setDes] = useState<string | undefined>(undefined); // undefined 的时候说明还未获取到疾病名（搜索词）

  const _provinceId = selectedProvince || provinceId;

  useEffect(() => {
    // 疾病ID换疾病名称
    if (diseaseId) {
      excuteFassScript({
        scriptScene: "QueryDiseaseByDiseaseId",
        diseaseId,
      })
        .then((data: any) => {
          if (data) {
            const diseaseName = data.diseaseName || "";
            setDes(diseaseName);
          } else {
            setDes("");
          }
        })
        .catch(() => {
          setDes("");
        });
    } else {
      setDes("");
    }
  }, []);

  useEffect(() => {
    let scriptScene =
      hospitalId && (departmentId || secondDepartId)
        ? "QueryHospitalAndDepart"
        : _provinceId || cityId
        ? "QueryAreaName"
        : "";
    // 医院ID && 科室id || 省、市ID查询名称
    if (scriptScene) {
      if (
        scriptScene == "QueryHospitalAndDepart" &&
        (isNaN(hospitalId) || isNaN(departmentId || secondDepartId))
      )
        return;
      if (scriptScene == "QueryAreaName" && isNaN(_provinceId || cityId))
        return;

      excuteFassScript({
        scriptScene: scriptScene || undefined,
        hospitalId: hospitalId || undefined,
        departId: departmentId || secondDepartId || undefined,
        departLevel: departmentId ? 1 : secondDepartId ? 2 : undefined,
        provinceId: _provinceId || undefined,
        cityId: cityId || undefined,
      }).then((data: any) => {
        if (data) {
          // 医院ID查询
          if (scriptScene == "QueryHospitalAndDepart") {
            const hospitalName =
              data?.commonName?.split(",")?.[0] || data?.hospitalName || "";
            const departName = data?.departName || "";
            setHospital(hospitalName);
            setDepart(departName);

            // 省、市查询
          } else if (scriptScene == "QueryAreaName") {
            const areaName = data?.areaName || "";
            setAreaName(areaName);
          }
        }
      });
    } else if (hospitalId && !departmentId && !secondDepartId) {
      // 只有医院ID
      getHospitalDetailByHospitalId({
        hospitalId: hospitalId,
      }).then((data: any) => {
        if (data) {
          const hospitalName =
            data?.commonName?.split(",")?.[0] || data?.hospitalName || "";
          const departName = data?.departName || "";
          setHospital(hospitalName);
          setDepart(departName);
        }
      });
    }
  }, []);

  const cardTitle1 = `${areaName || hospital || ""}${
    des || depart || secondDepartName || ""
  }专家`;
  // const cardTitle2 = `${areaName || hospital || ""}${
  //   des || depart || secondDepartName || ""
  // }患友问诊`;
  const cardTitle2 = `患友问诊`;
  const cardTitle3 = `科普文章`;

  const doctorParams = useMemo(()=>{
    const keyWords = {
      hospitalId: hospitalId || undefined,
      secondDepartmentId: secondDepartId || undefined,
      departmentId: departmentId || undefined,
      querySentence: des || undefined,
      provinceId: _provinceId || undefined,
      cityId: cityId || undefined,
    };
  
    if (des) {
      delete keyWords.departmentId;
      delete keyWords.secondDepartmentId;
    }
  
    if (keyWords.hospitalId) {
      delete keyWords.provinceId;
      delete keyWords.cityId;
    }
    return {
      pageSize: 10,
      // sceneCode: "masterStation",
      channel: 3,
      keyWords,
    }
  },[des])

  const reqParams = useRef({
    diseaseId,
    departmentId,
    secondDepartId,
  })

  console.log(999999,{ cardTitle1, cardTitle2, cardTitle3, doctorParams });

  return (
    <Template isDetail={true}>
      <div id={homeNav[0].id} className={styles.doctor}>
        {des === undefined ? null : (
          <PcseoDoctorSearch
            moreClickCallback={() => {
              // targetLink("/department/all-all");
            }}
            // moreUrl="/department/all-all"
            listParams={doctorParams}
            hideFilter={true}
            cardTitle={cardTitle1}
            hasYellowDoctor={true}
          />
        )}
      </div>
      <div id={homeNav[1].id} style={{ paddingBottom: "16px" }}>
        <InquiryCard
          // moreUrl="inquiryList"
          paging={false}
          hideDepartmentList={true}
          hideAllBtn={true}
          cardTitle={cardTitle2}
          limit={3}
          pageSize={10}
          isRecommend={true}
          reqParams={reqParams.current}
          hideWhenAnswerListNone={true}
        />
      </div>
      <div id={homeNav[2].id} style={{ paddingBottom: "16px" }}>
        <ArticleCard
          // moreUrl="articleList"
          paging={false}
          hideDepartmentList={true}
          hideAllBtn={true}
          cardTitle={cardTitle3}
          limit={articleLimit}
          pageSize={10}
          limitMoreComp={
            articleLimit ? (
              <div
                className={styles.evaluateListMore}
                onClick={() => {
                  setArticleLimit(undefined);
                }}
              >
                <p>
                  <span>展开更多</span>
                  <img src={evaluate5} alt="" />
                </p>
              </div>
            ) : null
          }
          isRecommend={true}
          reqParams={reqParams.current}
          hideWhenAnswerListNone={true}
        />
      </div>
    </Template>
  );
}
